import { Box } from '@mui/material';
import React from 'react';

const BUTTON_SX = {
  px: 1.25,
  py: 0.25,
  border: 'none',
  borderRadius: 0.5,
  cursor: 'pointer',
  fontSize: '12px',
} as const;

/**
 * Warning banner shown above a rich-text field when a paste looks like a
 * broken bullet list (a common artefact of copying from a PDF) — "Fix list"
 * rebuilds it, "Dismiss" just hides the banner.
 */
export default function PasteCleanupBanner({
  onFix,
  onDismiss,
}: {
  onFix: () => void;
  onDismiss: () => void;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.25,
        py: 0.75,
        mb: 0.5,
        bgcolor: '#fff8e1',
        border: '1px solid #ffe082',
        borderRadius: 1,
        fontSize: '12px',
        color: '#5d4037',
      }}
    >
      <span>⚠️ Looks like a broken bullet list was pasted.</span>
      <Box
        component="button"
        type="button"
        onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
        onClick={onFix}
        sx={{ ...BUTTON_SX, bgcolor: 'primary.main', color: '#fff' }}
      >
        Fix list
      </Box>
      <Box
        component="button"
        type="button"
        onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
        onClick={onDismiss}
        sx={{ ...BUTTON_SX, bgcolor: 'transparent', color: '#777', border: '1px solid #ccc' }}
      >
        Dismiss
      </Box>
    </Box>
  );
}
